var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "c-color-picker-wrapper" },
    [
      _vm.showInputMenu
        ? _c(_setup.CButtonGroup, {
            staticClass: "c-color-picker-menu mb-3 w-100",
            attrs: {
              "no-icon": "",
              type: "radio",
              size: "sm",
              wide: "",
              separate: "",
              center: "",
              items: _setup.pickerTypes,
            },
            on: { input: _setup.onChangePickerType },
            model: {
              value: _setup.pickerType,
              callback: function ($$v) {
                _setup.pickerType = $$v
              },
              expression: "pickerType",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.pickerType === _setup.ColorPickerType.SOLID
        ? _c(_setup.CSolidColor, {
            attrs: {
              "allow-reset": _vm.allowReset,
              "initial-color": _vm.initialColor,
              "reset-text": _vm.resetText,
              mode: _vm.mode,
            },
            on: {
              input: _setup.onUpdateColor,
              "using-eye-dropper": () => _setup.emit("using-eye-dropper"),
              "eye-dropper-used": () => _setup.emit("eye-dropper-used"),
            },
            model: {
              value: _setup.currentColorSolid,
              callback: function ($$v) {
                _setup.currentColorSolid = $$v
              },
              expression: "currentColorSolid",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.pickerType === _setup.ColorPickerType.GRADIENT
        ? _c(_setup.CGradientColor, {
            attrs: { mode: _vm.mode },
            on: { input: _setup.onUpdateColor },
            model: {
              value: _setup.currentColorGradient,
              callback: function ($$v) {
                _setup.currentColorGradient = $$v
              },
              expression: "currentColorGradient",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _setup.pickerType === _setup.ColorPickerType.PALETTE
        ? _c(_setup.CPaletteColor, {
            attrs: { mode: _vm.mode },
            on: { input: _setup.onUpdateColor },
            model: {
              value: _setup.currentColorPalette,
              callback: function ($$v) {
                _setup.currentColorPalette = $$v
              },
              expression: "currentColorPalette",
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm._t("footer"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }